import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import axios from "axios";
import { API_ESA_OFFICE } from "utils";
import { saveAs } from "file-saver";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

import Grid from "@mui/material/Grid";
import Chip from "@mui/material/Chip";
import Icon from "@mui/material/Icon";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

// Material Dashboard 2 PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

import { logoutUser } from "actions/AuthAction";

function DaftarHadirPimpinan() {
  const [daftarHadir, setDaftarHadir] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingListUser, setLoadingListUser] = useState(false);
  const [userId, setUserId] = useState(null);
  const [dinasId, setDinasId] = useState(null);
  const [selectedDate, setSelectedDate] = useState(() => {
    // Set default tanggal ke hari ini dengan WITA (UTC+8)
    const today = new Date();
    const witaOffset = 8 * 60; // UTC+8 dalam menit
    const witaDate = new Date(today.getTime() + witaOffset * 60 * 1000);
    return witaDate.toISOString().split("T")[0];
  });
  const [unitKerja, setUnitKerja] = useState(null);
  const [listUser, setListUser] = useState([]);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // Fungsi untuk menghitung rekap kehadiran
  const calculateAttendanceStats = () => {
    const stats = {
      hadir: 0,
      izin: 0,
      sakit: 0,
      cuti: 0,
      tugasBelajar: 0,
      tanpaBerita: 0,
      tidakAdaData: 0,
      total: daftarHadir.length,
    };

    daftarHadir.forEach((item) => {
      switch (item.status) {
        case "Hadir":
          stats.hadir++;
          break;
        case "Izin":
          stats.izin++;
          break;
        case "Sakit":
          stats.sakit++;
          break;
        case "Cuti":
          stats.cuti++;
          break;
        case "Tugas Belajar":
          stats.tugasBelajar++;
          break;
        case "Tanpa Berita":
          stats.tanpaBerita++;
          break;
        default:
          stats.tidakAdaData++;
          break;
      }
    });

    return stats;
  };

  const attendanceStats = calculateAttendanceStats();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      setUserId(user.id);
      setDinasId(user.dinas_id);
      setUnitKerja(user.nama_dinas);
    } else {
      logoutUser(navigate);
    }
  }, []);

  // Fetch list user pimpinan saat component mount
  useEffect(() => {
    fetchListUserPimpinan();
  }, []);

  useEffect(() => {
    if (listUser.length > 0) {
      fetchDaftarHadir();
    }
  }, [selectedDate, listUser]);

  // Fetch list user pimpinan dari backend
  const fetchListUserPimpinan = async () => {
    setLoadingListUser(true);
    try {
      const response = await axios.get(
        `${API_ESA_OFFICE}users/pimpinan/uid-list`
      );

      if (response.data.success === 1 && response.data.data) {
        setListUser(response.data.data);
      } else {
        setListUser([]);
        swal({
          title: "Warning",
          text: "Tidak ada data user pimpinan ditemukan",
          icon: "warning",
          button: "OK",
        });
      }
    } catch (error) {
      console.error("Error fetching list user pimpinan:", error);
      swal({
        title: "Error!",
        text: "Terjadi kesalahan saat mengambil data user pimpinan",
        icon: "error",
        button: "OK",
      });
      setListUser([]);
    } finally {
      setLoadingListUser(false);
    }
  };

  const fetchDaftarHadir = async () => {
    // Validasi bahwa listUser tidak kosong
    if (!listUser || listUser.length === 0) {
      swal({
        title: "Warning",
        text: "List user pimpinan kosong. Tidak dapat mengambil data daftar hadir.",
        icon: "warning",
        button: "OK",
      });
      setDaftarHadir([]);
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        "https://smartservice.rotendaokab.go.id/api/admin/daftarhadir/ambildhoharian/listuser",
        {
          tanggal: selectedDate,
          listUser: listUser,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success === 1) {
        // Urutkan data berdasarkan waktu masuk (yang paling awal di atas)
        const sortedData = response.data.data.sort((a, b) => {
          // Jika waktu masuk kosong, letakkan di bawah
          if (!a.waktuMasuk && !b.waktuMasuk) return 0;
          if (!a.waktuMasuk) return 1;
          if (!b.waktuMasuk) return -1;

          // Konversi waktu ke menit untuk perbandingan
          const timeA = a.waktuMasuk.split(":").map(Number);
          const timeB = b.waktuMasuk.split(":").map(Number);
          const minutesA = timeA[0] * 60 + timeA[1];
          const minutesB = timeB[0] * 60 + timeB[1];

          return minutesA - minutesB;
        });

        setDaftarHadir(sortedData);
      } else {
        setDaftarHadir([]);
        swal({
          title: "Info",
          text: "Tidak ada data daftar hadir untuk tanggal yang dipilih",
          icon: "info",
          button: "OK",
        });
      }
    } catch (error) {
      console.error("Error fetching daftar hadir:", error);
      swal({
        title: "Error!",
        text: "Terjadi kesalahan saat mengambil data daftar hadir",
        icon: "error",
        button: "OK",
      });
      setDaftarHadir([]);
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Hadir":
        return "success";
      case "Izin":
        return "warning";
      case "Sakit":
        return "error";
      case "Cuti":
        return "info";
      case "Tugas Belajar":
        return "secondary";
      case "Tanpa Berita":
        return "default";
      default:
        return "default";
    }
  };

  const formatWorkingHours = (workingHours) => {
    if (!workingHours || workingHours === "") {
      return "-";
    }
    return workingHours;
  };

  const columns = [
    {
      Header: "No",
      accessor: "no",
      width: "5%",
      Cell: ({ row }) => row.index + 1,
    },
    {
      Header: "Profil",
      accessor: "profil",
      width: "8%",
      Cell: ({ row }) => (
        <MDBox display="flex" alignItems="center">
          <img
            src={`https://smartdh.rotendaokab.go.id/uploads/${row.original.uid}.jpg`}
            alt={row.original.nama}
            style={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              objectFit: "cover",
              border: "2px solid #e0e0e0",
            }}
            onError={(e) => {
              // Jika gambar tidak ditemukan, tampilkan icon default
              e.target.style.display = "none";
              e.target.nextSibling.style.display = "flex";
            }}
          />
          <MDBox
            display="none"
            alignItems="center"
            justifyContent="center"
            sx={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              backgroundColor: "grey.200",
              color: "grey.500",
            }}
          >
            <Icon sx={{ fontSize: 20 }}>person</Icon>
          </MDBox>
        </MDBox>
      ),
    },
    {
      Header: "Nama",
      accessor: "nama",
      width: "22%",
    },
    {
      Header: "Status",
      accessor: "status",
      width: "10%",
      Cell: ({ value }) => (
        <Chip
          label={value || "Tidak Ada Data"}
          color={getStatusColor(value)}
          size="small"
          variant="filled"
        />
      ),
    },
    {
      Header: "Waktu Masuk",
      accessor: "waktuMasuk",
      width: "12%",
      Cell: ({ value }) => (
        <MDTypography variant="caption" fontWeight="medium">
          {value || "-"}
        </MDTypography>
      ),
    },
    {
      Header: "Waktu Pulang",
      accessor: "waktuPulang",
      width: "12%",
      Cell: ({ value }) => (
        <MDTypography variant="caption" fontWeight="medium">
          {value || "-"}
        </MDTypography>
      ),
    },
    {
      Header: "Jam Kerja",
      accessor: "workingHours",
      width: "12%",
      Cell: ({ value }) => (
        <MDTypography variant="caption" fontWeight="medium">
          {formatWorkingHours(value)}
        </MDTypography>
      ),
    },
    {
      Header: "Tanggal",
      accessor: "tanggal",
      width: "12%",
      Cell: ({ value }) => (
        <MDTypography variant="caption" fontWeight="medium">
          {value || "-"}
        </MDTypography>
      ),
    },
  ];

  const handleExportExcel = () => {
    if (!daftarHadir.length) {
      swal({
        title: "Info",
        text: "Tidak ada data untuk di-export",
        icon: "info",
        button: "OK",
      });
      return;
    }

    // Buat HTML table untuk Excel
    const tableHeaders = [
      "No",
      "Nama",
      "Status",
      "Waktu Masuk",
      "Waktu Pulang",
      "Jam Kerja",
      "Tanggal",
    ];

    let tableRows = "";
    daftarHadir.forEach((row, index) => {
      tableRows += `
        <tr>
          <td>${index + 1}</td>
          <td>${row.nama || ""}</td>
          <td>${row.status || "Tidak Ada Data"}</td>
          <td>${row.waktuMasuk || "-"}</td>
          <td>${row.waktuPulang || "-"}</td>
          <td>${row.workingHours || "-"}</td>
          <td>${row.tanggal || "-"}</td>
        </tr>
      `;
    });

    const htmlContent = `
      <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
        <head>
          <meta charset="UTF-8">
          <title>Daftar Hadir Pimpinan - ${selectedDate}</title>
          <style>
            table { border-collapse: collapse; width: 100%; }
            th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
            th { background-color: #f2f2f2; font-weight: bold; }
          </style>
        </head>
        <body>
          <h2>Daftar Hadir Pimpinan Smart DH - ${selectedDate}</h2>
          <table>
            <thead>
              <tr>
                ${tableHeaders.map((header) => `<th>${header}</th>`).join("")}
              </tr>
            </thead>
            <tbody>
              ${tableRows}
            </tbody>
          </table>
        </body>
      </html>
    `;

    const blob = new Blob([htmlContent], {
      type: "application/vnd.ms-excel;charset=utf-8",
    });
    saveAs(blob, `daftar-hadir-pimpinan-${selectedDate}.xls`);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <MDBox mb={3}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <MDTypography variant="h4">
                Daftar Hadir Pimpinan Smart DH
              </MDTypography>
            </Grid>
            <Grid item>
              <MDBox display="flex" gap={1}>
                <MDButton
                  variant="gradient"
                  color="info"
                  onClick={() => {
                    if (listUser.length > 0) {
                      fetchDaftarHadir();
                    } else {
                      swal({
                        title: "Warning",
                        text: "List user pimpinan kosong. Silakan refresh halaman.",
                        icon: "warning",
                        button: "OK",
                      });
                    }
                  }}
                  disabled={loading || loadingListUser || listUser.length === 0}
                >
                  <Icon>refresh</Icon>&nbsp;{loading ? "Memuat..." : "Refresh"}
                </MDButton>
                <MDButton
                  variant="outlined"
                  color="dark"
                  onClick={handleExportExcel}
                  disabled={!daftarHadir.length}
                >
                  <Icon>description</Icon>
                  &nbsp;Export Excel
                </MDButton>
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>

        {/* Rekap Kehadiran */}
        <MDBox mb={3}>
          <MDTypography variant="h6" color="text" mb={2}>
            Rekap Kehadiran - {selectedDate}
          </MDTypography>
          <Grid container spacing={2} alignItems="center">
            <Grid item>
              <Chip
                icon={<Icon>check_circle</Icon>}
                label={`Hadir: ${attendanceStats.hadir}`}
                color="success"
                variant="filled"
                sx={{ fontSize: "0.875rem", fontWeight: "bold" }}
              />
            </Grid>
            <Grid item>
              <Chip
                icon={<Icon>warning</Icon>}
                label={`Izin: ${attendanceStats.izin}`}
                color="warning"
                variant="filled"
                sx={{ fontSize: "0.875rem", fontWeight: "bold" }}
              />
            </Grid>
            <Grid item>
              <Chip
                icon={<Icon>local_hospital</Icon>}
                label={`Sakit: ${attendanceStats.sakit}`}
                color="error"
                variant="filled"
                sx={{ fontSize: "0.875rem", fontWeight: "bold" }}
              />
            </Grid>
            <Grid item>
              <Chip
                icon={<Icon>event_busy</Icon>}
                label={`Cuti: ${attendanceStats.cuti}`}
                color="info"
                variant="filled"
                sx={{ fontSize: "0.875rem", fontWeight: "bold" }}
              />
            </Grid>
            <Grid item>
              <Chip
                icon={<Icon>school</Icon>}
                label={`Tugas Belajar: ${attendanceStats.tugasBelajar}`}
                color="secondary"
                variant="filled"
                sx={{ fontSize: "0.875rem", fontWeight: "bold" }}
              />
            </Grid>
            <Grid item>
              <Chip
                icon={<Icon>not_interested</Icon>}
                label={`Tanpa Berita: ${attendanceStats.tanpaBerita}`}
                sx={{
                  fontSize: "0.875rem",
                  fontWeight: "bold",
                  backgroundColor: "#424242",
                  color: "white",
                }}
              />
            </Grid>
            <Grid item>
              <Chip
                icon={<Icon>help_outline</Icon>}
                label={`Tidak Ada Data: ${attendanceStats.tidakAdaData}`}
                color="default"
                variant="filled"
                sx={{ fontSize: "0.875rem", fontWeight: "bold" }}
              />
            </Grid>
            <Grid item>
              <Chip
                icon={<Icon>group</Icon>}
                label={`Total: ${attendanceStats.total}`}
                color="primary"
                variant="filled"
                sx={{ fontSize: "0.875rem", fontWeight: "bold" }}
              />
            </Grid>
          </Grid>
          <MDBox mt={1}>
            <MDTypography variant="caption" color="text.secondary">
              {unitKerja}
            </MDTypography>
            <MDTypography
              variant="caption"
              color="text.secondary"
              display="block"
            >
              Total User Pimpinan: {listUser.length} orang
            </MDTypography>
          </MDBox>
        </MDBox>

        <MDBox mb={3}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <MDInput
                type="date"
                label="Pilih Tanggal"
                fullWidth
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item xs={12} md={2}>
              <MDButton
                variant="gradient"
                color="success"
                onClick={() => {
                  if (listUser.length > 0) {
                    fetchDaftarHadir();
                  } else {
                    swal({
                      title: "Warning",
                      text: "List user pimpinan kosong. Tidak dapat mengambil data daftar hadir.",
                      icon: "warning",
                      button: "OK",
                    });
                  }
                }}
                disabled={loading || loadingListUser || listUser.length === 0}
                fullWidth
              >
                <Icon>search</Icon>&nbsp;Cari
              </MDButton>
            </Grid>
          </Grid>
        </MDBox>

        <MDBox mb={2}>
          <MDTypography variant="h6" color="text">
            Data Daftar Hadir: {selectedDate}
          </MDTypography>
          <MDTypography variant="caption" color="text">
            Total: {daftarHadir.length} pegawai
          </MDTypography>
        </MDBox>

        {isMobile ? (
          <MDBox display="flex" flexDirection="column" gap={1}>
            {loading && (
              <MDTypography variant="button" color="text.secondary">
                Memuat...
              </MDTypography>
            )}
            {!loading &&
              daftarHadir.map((row, index) => (
                <Card key={`${row.uid || row.nama || "row"}-${index}`}>
                  <CardContent>
                    <Grid container spacing={1} alignItems="center">
                      <Grid item xs={4}>
                        <MDBox
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <img
                            src={`https://smartdh.rotendaokab.go.id/uploads/${row.uid}.jpg`}
                            alt={row.nama}
                            style={{
                              width: 72,
                              height: 72,
                              borderRadius: "50%",
                              objectFit: "cover",
                              border: "2px solid #e0e0e0",
                            }}
                            onError={(e) => {
                              e.target.style.display = "none";
                              e.target.nextSibling.style.display = "flex";
                            }}
                          />
                          <MDBox
                            display="none"
                            alignItems="center"
                            justifyContent="center"
                            sx={{
                              width: 72,
                              height: 72,
                              borderRadius: "50%",
                              backgroundColor: "grey.200",
                              color: "grey.500",
                            }}
                          >
                            <Icon sx={{ fontSize: 36 }}>person</Icon>
                          </MDBox>
                        </MDBox>
                      </Grid>
                      <Grid item xs={8}>
                        <MDTypography variant="button" fontWeight="bold">
                          {index + 1}. {row.nama}
                        </MDTypography>
                        <MDBox
                          mt={0.5}
                          display="flex"
                          alignItems="center"
                          gap={1}
                        >
                          <Chip
                            label={row.status || "Tidak Ada Data"}
                            color={getStatusColor(row.status)}
                            size="small"
                          />
                          <MDTypography
                            variant="caption"
                            color="text.secondary"
                          >
                            {row.tanggal || "-"}
                          </MDTypography>
                        </MDBox>
                        <MDBox mt={1}>
                          <Grid container spacing={1}>
                            <Grid item xs={6}>
                              <MDTypography
                                variant="caption"
                                color="text.secondary"
                              >
                                Masuk
                              </MDTypography>
                              <MDTypography variant="button">
                                {row.waktuMasuk || "-"}
                              </MDTypography>
                            </Grid>
                            <Grid item xs={6}>
                              <MDTypography
                                variant="caption"
                                color="text.secondary"
                              >
                                Pulang
                              </MDTypography>
                              <MDTypography variant="button">
                                {row.waktuPulang || "-"}
                              </MDTypography>
                            </Grid>
                            <Grid item xs={12}>
                              <MDTypography
                                variant="caption"
                                color="text.secondary"
                              >
                                Jam Kerja
                              </MDTypography>
                              <MDTypography variant="button">
                                {formatWorkingHours(row.workingHours)}
                              </MDTypography>
                            </Grid>
                          </Grid>
                        </MDBox>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              ))}
          </MDBox>
        ) : (
          <DataTable
            table={{
              columns,
              rows: daftarHadir,
            }}
            entriesPerPage={false}
            showTotalEntries={false}
            isSorted={false}
            noEndBorder
            loading={loading}
          />
        )}

        {daftarHadir.length === 0 && !loading && (
          <MDBox
            display="flex"
            flexDirection="column"
            alignItems="center"
            py={4}
          >
            <Icon sx={{ fontSize: 64, color: "text.secondary", mb: 2 }}>
              event_busy
            </Icon>
            <MDTypography variant="h6" color="text.secondary">
              Tidak ada data daftar hadir
            </MDTypography>
            <MDTypography variant="body2" color="text.secondary">
              Coba pilih tanggal lain atau periksa kembali unit kerja
            </MDTypography>
          </MDBox>
        )}
      </MDBox>
    </DashboardLayout>
  );
}

export default DaftarHadirPimpinan;
